/**
 * Storage Service Export
 * Automatisch de goede pakken (native of web)
 * 
 * Metro regelt dit automagisch:
 * - storage.native.ts voor iOS/Android
 * - storage.web.ts voor web
 */

export type {StorageService} from './StorageService';
export {storageService} from './storage';
